import { render, staticRenderFns } from "./riskPreventionDialog.vue?vue&type=template&id=561092ee&scoped=true"
import script from "./riskPreventionDialog.vue?vue&type=script&lang=js"
export * from "./riskPreventionDialog.vue?vue&type=script&lang=js"
import style0 from "./riskPreventionDialog.vue?vue&type=style&index=0&id=561092ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561092ee",
  null
  
)

export default component.exports